import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
export type ContainerStationDetailFragment = { __typename?: 'ContainerStation', id: string, name: string, store_id: string, epc_tag: string, is_recalled: boolean, item_type: { __typename?: 'ItemType', id: number, name: string, color_hex_code?: string | null, category: Types.ItemTypeCategory, epc_asset_id: number, image_url?: string | null }, store: { __typename?: 'Store', id: string, name?: string | null }, stock: Array<{ __typename?: 'ContainerStationStock', id: number, name: string, amount: number, image_url?: string | null, sealed: boolean }> };

export const ContainerStationDetailFragmentDoc = gql`
    fragment ContainerStationDetail on ContainerStation {
  id
  name
  store_id
  item_type {
    id
    name
    color_hex_code
    category
    epc_asset_id
    image_url
  }
  epc_tag
  is_recalled
  store {
    id
    name
  }
  stock {
    id
    name
    amount
    image_url
    sealed
  }
}
    `;